import { RegionalFiltersData } from "@assets/mocks/filterData";
import { useNavigate } from "react-router";
interface Props {
  id: number;
}

import Country from "../../../../../assets/icons/regionalIcons/noun-europe-6606119-1C1B2D.png";

import Radius from "../../../../../assets/icons/regionalIcons/noun-radius-5247683-1C1B2D.png";


const RegionalFilters :React.FC<Props>= ({id}) => {
  const navigate = useNavigate();

  
  const iconsList = [
    {
      
      src: Country
    },
    {
      
      src: Radius
    },
    
  ];

  return (
    <div className="w-2/3">
      <div className="flex gap-3">
        {RegionalFiltersData.slice(0, 3)?.map((val, index) => {
          return (
            <div
              className="bg-white flex justify-center items-center text-center px-4 flex-col h-52 rounded-lg w-1/3 cursor-pointer"
              onClick={() => navigate(`/targetMarkets/targetMarketDetail/${id}/?filter=${val.path}`)}
            >
            <img
                src={iconsList[index].src}
                alt=""
                className="h-[75px]"
              />
              <h6 className="text-gray text-lg font-medium pt-2 pb-3">
                {val.title}
              </h6>
              <p className="text-[#71717A] text-sm">{val.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegionalFilters;
